module.exports = __webpack_public_path__ + "../static/img/logo-light.c92032cc.svg";